// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body:has(.Addons) .Dropdown-Item.active {
  background-color: var(--bs-primary) !important;
}
body:has(.Addons) .Dropdown-Item:hover {
  background-color: rgba(var(--bs-primary-rgb), 0.75) !important;
}`, "",{"version":3,"sources":["webpack://./src/features/Addons/styles.scss"],"names":[],"mappings":"AAEI;EACE,8CAAA;AADN;AAGI;EACE,8DAAA;AADN","sourcesContent":["body:has(.Addons) {\n  .Dropdown-Item {\n    &.active {\n      background-color: var(--bs-primary) !important;\n    }\n    &:hover {\n      background-color: rgba(var(--bs-primary-rgb), 0.75) !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
